function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.2 12.71"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m21838.501 1560.678 8.499-8.298 2.1 2.12-10.6 10.61zm-10.601-6.178 2.1-2.12 8.501 8.298v4.432z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    transform: "translate(-21827.9 -1552.38)"
  }));
};
export default SvgArrowDown;